<template>
    <div class="h-100 border rounded bg-white shadow-sm overflow-hidden" style="border-left: 5px solid var(--primary-600)!important;">
        <!-- <a :class="(small ? 'a-bg-hover' : '') + ' h-100 link-box'" :href="small ? getUseActiveTuUrl() : undefined "> -->
            <div :class="small ? 'py-2 px-3' : 'py-3 px-4'" style="height: 100%;">
                <div v-if="!hidePortalName || !hideLogo" class="w-100 d-flex justify-content-between align-items-start pb-2">
                    <h4 v-if="!hidePortalName" class="mb-3 font-weight-bold">{{ tenantUser.tenant_portal_name }}</h4>
                    
                    <div class="d-flex justify-content-start align-items-center">
                        <div v-if="!hideLogo && tenantUser.tenant_logo">
                            <img
                                :src="tenantUser.tenant_logo"
                                alt="Supplios"
                                height="40"
                            >
                        </div>
                    </div>
                </div>

                <div class="h-100 d-flex align-items-center">
                    <div class="flex-grow-1 h-100 p-1 d-flex flex-column justify-content-between">

                        <div class="">
                            <div class="font-size-80 font-weight-bold text-uppercase">
                                <span v-if="isInternalTu" class="text-accent">Internal User</span>
                                <span v-else class="text-danger-600">Supplier</span>
                            </div>
                            <div v-if="small || !isInternalTu" class="mt-1 font-size-110 font-weight-500">
                                {{ tenantUser.tenant_user_company_name }}
                            </div>
                        </div>
                        <!-- <div class="spl-dlist d-flex">
                            <dt class="width-150 text-right">Role</dt>
                            <dd class="ml-3 flex-fill">
                                {{ tenantUser.tenant_user_role_name }}
                                <div v-if="!tenantUser.tenant_user_fully_active"></div>
                            </dd>
                        </div> -->
                        
                        <!-- <div class="spl-dlist d-flex">
                            <dt class="width-150 text-right">Company</dt>
                            <dd class="ml-3 flex-fill">{{ tenantUser.tenant_user_company_name }}</dd>
                        </div> -->

                        <div :class="small ? 'mt-1' : 'mt-3'">
                            <div class="">
                                <base-popover-icon
                                    class="mr-1 small"
                                    title="Linked Email"
                                    content="For security reasons, only Company admins can change the email used to link you to the company.  If you need to change this, please contact a Company admin or Supplios Support."
                                ></base-popover-icon>
                                <span class="text-uppercase text-muted font-size-70">Linked Email</span>
                            </div>
                            <div>{{ tenantUser.tenant_user_email }}</div>
                        </div>

                        <!-- <div class="spl-dlist d-flex">
                            <dt class="width-150 text-right">
                                <base-popover-icon
                                    class="mr-1"
                                    title="Linked Email"
                                    content="For security reasons, only Company admins can change the email used to link you to the company.  If you need to change this, please contact a Company admin or Supplios Support."
                                ></base-popover-icon>
                                Linked Email
                            </dt>
                            <dd class="ml-3 flex-fill">{{ tenantUser.tenant_user_email }}</dd>
                        </div> -->
                    </div>

                    <div class="d-flex flex-column mt-2 justify-content-end align-items-center">
                        <div v-if="!tenantUser.invited">
                            <div v-if="tenantUser.authenticated">
                                <b-button :href="getUseActiveTuUrl()" variant="minimal-primary" class="py-3">
                                    Go to dashboard
                                    <b-icon icon="chevron-right"></b-icon>
                                </b-button>
                            </div>
                            <div v-if="!tenantUser.authenticated && !small">
                                <b-button @click="switchAccountsClicked" variant="minimal-primary">
                                    Switch to this account
                                    <b-icon icon="chevron-right"></b-icon>
                                </b-button>
                            </div>
                            <div v-if="!hideManageAccounts && tenantUser.tenant_enabled_manage_accounts && !small">
                                <b-button :href="`/profile/${tenantUser.tenant_user_id}`" variant="minimal-primary">
                                    Manage account
                                    <b-icon icon="chevron-right"></b-icon>
                                </b-button>
                            </div>
                        </div>
                        <div v-else>
                            <b-button @click="onConnectTuClicked" variant="minimal-primary">
                                Connect user
                                <b-icon icon="chevron-right"></b-icon>
                            </b-button>
                        </div>
                    </div>
                </div>
            </div>
        <!-- </a> -->
    </div>
</template>

<script>

export default {
    name: 'IdentityLine',
    components: {},
    props: {
        tenantUser: {
            type: Object,
            required: true
        },
        nexturl: {
            type: String,
            default: ''
        },
        hideManageAccounts: {
            type: Boolean,
            default: false
        },
        hideLogo: {
            type: Boolean,
            default: false
        },
        hidePortalName: {
            type: Boolean,
            default: false
        },
        small: {
            type: Boolean,
            default: false,
        },
    },
    data: function() {
        return {
            hovered: true,
        }
    },
    computed: {
        isInternalTu() {
            return this.tenantUser.tenant_user_is_internal;
        },
    },
    methods: {
        getUseActiveTuUrl() {
          return this.tenantUser.set_active_tu_url;
        },
        switchAccountsClicked() {
            // pass up the dashboard URL that you want to go to, the parent component then passes it to the logout component, and it redirects there instead of the normal logout URL
            this.$emit('switch-accounts-clicked', this.tenantUser.tenant_user_dashboard_url);
        },
        onConnectTuClicked() {
            this.$emit('connect-tu-clicked', this.tenantUser.tenant_user_id);
        },
    }
}
</script>

<style scoped lang="scss">

.link-box:link {
    text-decoration: none !important;
    color: $black;
}

.link-box:visited {
    text-decoration: none !important;
    color: $black;
}

.link-box:hover {
    text-decoration: none !important;
    color: $black;
}

.link-box:active {
    text-decoration: none !important;
    color: $black;
}

.link-box {
    color: $black;
}

.authentication-method-a {
    color: black;
    transition: 200ms;
}
.authentication-method-a:hover {
    color: black;
    text-decoration: none;
}
.authentication-method-card:hover {
    transition: 200ms;
    background-color: rgba(33, 33, 33, 0.1);
}

.active-line{
    border:1px solid blue;
}

.active-box, .change-to-account-box {
    position: absolute;
    top: 0.5rem;
    right: 0.5rem;
    background-color: #1e98e0;
    border-radius: 6px;
    font-size: 8pt;
    color: white;
    /* max-width: 3rem; */
    padding: 0.2rem 0.4rem;
}

.change-to-account-box {
    visibility: hidden;
    transition: 300ms;
    background-color: #0c9f6e;
    transition: visibility 0s, opacity 0.5s linear;
}

.authentication-method-card:hover .change-to-account-box {
    visibility: visible;
    transition: 300ms;
    opacity: 1;
}
</style>
